module.exports = __webpack_public_path__ + "fonts/dm-sans-v10-latin-regular.71edbde.woff2";